import React, { useState, useEffect } from 'react';
import UDIRowPopup, { UDIPopupField, UDIAddRowButton, useUDIRowPopup } from './UDIRowPopup.js';

const ContainerPack = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.EUProductUDI.ContainerPackagesRelatedTo_UDI_DI",
    fieldTitle = "Container Packages related to UDI-DI",
    forceIsEditing = null
}) => {
    // Dictionaries
    const issuingEntities = [
        { key: "GS1", value: "GS1" },
        { key: "HIBCC", value: "HIBCC" },
        { key: "ICCBBA", value: "ICCBBA" },
        { key: "IFA", value: "IFA" },
        { key: "EUDAMED", value: "EUDAMED" }
    ];

    const packStatuses = [
        { key: "ON_THE_MARKET", value: "On the EU market" },
        { key: "NO_LONGER_PLACED_ON_THE_MARKET", value: "No longer placed on the EU market" },
        { key: "NOT_INTENDED_FOR_EU_MARKET", value: "Not intended for the EU market" }
    ];

    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch {
            return [];
        }
    });

    const initialFormState = {
        IssuingEntity: { Value: 'GS1', Text: 'GS1' },
        PackageUDIDI: '',
        QuantityPerPackage: '',
        RelatedPackage: '',
        Status: { Value: 'ON_THE_MARKET', Text: 'On the EU market' }
    };

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [formData, setFormData] = useState(initialFormState);
    const [editingIndex, setEditingIndex] = useState(null);

    // --- Handlers ---

    const handleSelectChange = (e, field) => {
        const value = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;
        setFormData(prev => ({
            ...prev,
            [field]: { Value: value, Text: text }
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        const updatedItems = [...items];
        if (editingIndex !== null) {
            updatedItems[editingIndex] = formData;
        } else {
            updatedItems.push(formData);
        }

        setItems(updatedItems);

        // Sync with Global 
        setUDI(prevItem => ({
            ...prevItem,
            ContainerPackagesRelatedTo_UDI_DI: updatedItems
        }));

        popup.close();
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            ContainerPackagesRelatedTo_UDI_DI: updatedItems
        }));

        resetForm();
    };

    const handleEdit = (index) => {
        setFormData(items[index]);
        setEditingIndex(index);
        popup.openEdit();
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setEditingIndex(null);
    };

    const popup = useUDIRowPopup(resetForm);



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);



    // --- Render Mode: Edit ---
    return (


        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?

                            <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Issuing Entity</th>
                                            <th>Package UDI-DI</th>
                                            <th>Quantity Per Package</th>
                                            <th>Related Package</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr
                                                key={index}
                                                className={editingIndex === index ? 'udi-complex-field-row-selected' : ''}
                                            >
                                                <td>{item.IssuingEntity?.Text}</td>
                                                <td>{item.PackageUDIDI}</td>
                                                <td>{item.QuantityPerPackage}</td>
                                                <td>{item.RelatedPackage}</td>
                                                <td>{item.Status?.Text}</td>
                                                <td>
                                                    <button type="button" className="udiEditButton" onClick={() => handleEdit(index)}>
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    <button type="button" className="udiRemoveButton" onClick={() => handleRemove(index)}>
                                                        <i className="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <UDIAddRowButton label="Add Container Package" onClick={popup.openAdd} />

                                <UDIRowPopup
                                    isOpen={popup.isOpen}
                                    title={editingIndex !== null ? "Edit Container Package" : "Add Container Package"}
                                    saveLabel={editingIndex !== null ? "Save" : "Add"}
                                    onClose={popup.close}
                                    onSave={handleSave}
                                >
                                    <UDIPopupField label="Issuing Entity">
                                        <select value={formData.IssuingEntity.Value} onChange={(e) => handleSelectChange(e, 'IssuingEntity')}>
                                            {issuingEntities.map(ent => <option key={ent.key} value={ent.key}>{ent.value}</option>)}
                                        </select>
                                    </UDIPopupField>
                                    <UDIPopupField label="Package UDI-DI">
                                        <input type="text" name="PackageUDIDI" value={formData.PackageUDIDI} onChange={handleInputChange} />
                                    </UDIPopupField>
                                    <UDIPopupField label="Quantity per package">
                                        <input type="text" name="QuantityPerPackage" value={formData.QuantityPerPackage} onChange={handleInputChange} />
                                    </UDIPopupField>
                                    <UDIPopupField label="Related Package">
                                        <input type="text" name="RelatedPackage" value={formData.RelatedPackage} onChange={handleInputChange} />
                                    </UDIPopupField>
                                    <UDIPopupField label="Container Pack Status">
                                        <select value={formData.Status.Value} onChange={(e) => handleSelectChange(e, 'Status')}>
                                            {packStatuses.map(status => <option key={status.key} value={status.key}>{status.value}</option>)}
                                        </select>
                                    </UDIPopupField>
                                </UDIRowPopup>

                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </div>

                            :


                            <>

                                <table className="dataTable" style={{ borderWidth: '1px', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Issuing Entity</th>
                                            <th>Package UDI-DI</th>
                                            <th>Quantity Per Package</th>
                                            <th>Related Package</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.IssuingEntity?.Text}</td>
                                                <td>{item.PackageUDIDI}</td>
                                                <td>{item.QuantityPerPackage}</td>
                                                <td>{item.RelatedPackage}</td>
                                                <td>{item.Status?.Text}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/*
						        <input
							        type="button"
							        className="udiActionButton"
							        value="Edit"
							        onClick={() => changeIsEditingField(true)}
						        />
                                */}


                            </>

                        }

                    </div>

                </div>
            </div>
        </div>



    );
};

export default ContainerPack;